import { expertServices, pattern } from '../utils/constant'

export const expertFormModels = (facilities, lockFacility) => {
  return [
    {
      type: 'input',
      label: 'first name',
      dbField: 'first_name',
      colSpan: 12,
      rules: [{ required: true, message: 'This field is required' }]
    },
    {
      type: 'input',
      label: 'last name',
      dbField: 'last_name',
      colSpan: 12,
      rules: [{ required: true, message: 'This field is required' }]
    },
    {
      type: 'input',
      label: 'email',
      dbField: 'email',
      colSpan: 12,
      rules: [
        { required: true, message: 'This field is required' },
        {
          pattern: pattern.email,
          message: 'Please input a valid email'
        }
      ]
    },
    {
      type: 'radios',
      label: 'gender',
      dbField: ['profile', 'gender'],
      colSpan: 12,
      options: [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' }
      ],
      rules: [{ required: true, message: 'This field is required' }]
    },
    {
      type: 'multipleSelect',
      options: facilities.map((facility) => {
        return {
          value: facility.id,
          label: facility.name
        }
      }),
      disabled: lockFacility,
      dbField: ['facility_ids'],
      label: 'FACILITY',
      colSpan: 12,
      rules: [{ required: true, message: 'This field is required' }]
    },
    {
      type: 'input',
      label: 'phone number',
      colSpan: 12,
      dbField: ['profile', 'phone_number'],
      rules: [{ required: true, message: 'This field is required' }]
    },
    {
      type: 'tagSelect',
      label: 'SERVICE',
      colSpan: 24,
      dbField: ['services'],
      options: expertServices,
      rules: [{ required: true, message: 'This field is required' }]
    }
  ]
}
